<script>

import TextareaTemplates from "@/components/TextareaTemplates.vue";
import FileBrowser from "@/components/FileBrowser.vue";

export default {
  components: {
    FileBrowser,
    TextareaTemplates,
  },
  props: {
    drupalTextareaId: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      templatesDialog: false,
    }
  },
  methods: {
    openTemplatesDialog() {
      this.templatesDialog = true;
    },
    closeTemplatesDialog() {
      this.templatesDialog = false;
    },
    templateSelected(template) {
      // Add the value in the Drupal DOM textarea element
      this.setTextareaValue(template.template_text);
      // Add the value in the Drupal CKEditor element (if it exists)
      if (this.drupalTextareaHasCkeditorEnabled()) {
        this.setCkeditorValue(template.template_html);
      }
      // Close the dialog
      this.closeTemplatesDialog();
    },
    setTextareaValue(value) {
      const $textarea = this.drupalTextareaElement();
      // Get textarea values before and after selection
      let cursorPosition = $textarea.selectionStart;
      let textareaValueBefore = $textarea.value.substring(0, cursorPosition);
      let textareaValueAfter = $textarea.value.substring(cursorPosition);
      // Add template value at the position of the cursor
      $textarea.value = textareaValueBefore + value + textareaValueAfter;
      // Trigger 'input' event to make sure the auto grow textarea is updated
      $textarea.dispatchEvent(new Event('input', { bubbles: true }));
    },
    setCkeditorValue(value) {
      const $textarea = this.drupalTextareaElement();
      // Get the CKEditor instance
      const editor = Drupal.CKEditor5Instances.get(
        $textarea.getAttribute('data-ckeditor5-id'),
      );
      // Prepare and add content to the CKEditor body
      const viewFragment = editor.data.processor.toView(value);
      const modelFragment = editor.data.toModel( viewFragment );
      // Content is automatically inserted on the location of the cursor
      editor.model.insertContent(modelFragment);
    },
    /**
     * Get the Drupal DOM textarea element.
     *
     * @returns {Element}
     */
    drupalTextareaElement() {
      // Get the Drupal DOM input element
      const element_id = "#"+this.drupalTextareaId;
      return document.querySelector(element_id);
    },
    /**
     * Check if the Drupal DOM textarea element has CKEditor enabled.
     *
     * @returns {boolean}
     */
    drupalTextareaHasCkeditorEnabled() {
      const $textarea = this.drupalTextareaElement();
      if ($textarea.getAttribute('data-ckeditor5-id')) {
        return true;
      }
      return false;
    },
  },
}
</script>


<template>

  <Button label="Sjabloon invoegen" size="small" text @click="openTemplatesDialog">
    <template #icon><i class="far fa-file-alt"></i></template>
  </Button>

  <!-- Templates dialog -->
  <Dialog v-model:visible="templatesDialog" modal maximizable header="Kies een sjabloon" :style="{ width: '60rem' }">
    <TextareaTemplates @template-selected="templateSelected"></TextareaTemplates>
  </Dialog>

</template>

<style lang="scss">

</style>
